export default {"src":"/_next/static/media/cookie.30907c67.svg","height":117,"width":127,"blurWidth":0,"blurHeight":0};